<template>
  <div class="px-4 leading-base break-words survey-title" ref="info">
    <div ref="titleContainer" class="title text-20 font-bold mb-3 text-center" v-html="title" :style="titleStyle"></div>
    <div ref="descContainer" class="desc pb-3 box-border mt-1" v-html="welcome" :style="titleStyle"></div>
  </div>
</template>

<script>
import { busGetters, defaultsSurveyAttr, filterParams } from 'dygc'
import { previewImage } from '../assets/js/preview-image'

export default {
  name: 'PureTitleAndWelcome',
  computed: {
    titleStyle() {
      const data = this.cover.title || {}
      return filterParams({
        color: data.color,
        fontSize: data.size
      })
    },
    otherSetting() {
      return this.survey.otherSetting || {}
    },
    cover() {
      return this.otherSetting.cover || {}
    },
    title() {
      return this.survey.titlex || this.survey.title
    },
    welcome() {
      return this.survey.welcome || ''
    },
    ...busGetters(['survey'])
  },
  mounted() {
    previewImage(this.$refs.info)
  }
}
</script>
